export default __webpack_public_path__ + "static/media/check.03788315.svg";